const mulberry32 = (seed: number): (() => number) => {
  let s = seed >>> 0;
  return (): number => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

const hashLabel = (seed: number, label: string): number => {
  let h = (seed ^ 2166136261) >>> 0;
  for (let i = 0; i < label.length; i++) {
    h = Math.imul(h ^ label.charCodeAt(i), 16777619);
  }
  return h >>> 0;
};

export class Rng {
  private readonly _seed: number;
  private readonly _next: () => number;

  constructor(seed: number) {
    this._seed = seed >>> 0;
    this._next = mulberry32(this._seed);
  }

  get seed(): number {
    return this._seed;
  }

  float(): number {
    return this._next();
  }

  range(min: number, max: number): number {
    return min + this._next() * (max - min);
  }

  int(minInclusive: number, maxExclusive: number): number {
    return minInclusive + Math.floor(this._next() * (maxExclusive - minInclusive));
  }

  derive(label: string): Rng {
    return new Rng(hashLabel(this._seed, label));
  }
}
